import { version } from "../../package.json";

// Capture launch metadata before routing removes the initial query parameters.
const hostVersion = new URLSearchParams(window.location.search).get("hostVersion")?.trim();

// CI injects the build version and commit; local builds fall back to package.json.
const buildVersion = import.meta.env.VITE_APP_VERSION?.trim() || version;
const commit = import.meta.env.VITE_APP_COMMIT?.trim().slice(0, 7);
const frontendVersion = commit ? `${buildVersion} (${commit})` : buildVersion;

export const appVersion = hostVersion ? `${hostVersion}/${frontendVersion}` : frontendVersion;
